var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 0.5H14.375C15.3906 0.5 16.25 1.35938 16.25 2.375V4.25H18.2031C18.8672 4.25 19.5312 4.52344 20 4.99219L23.0078 8C23.4766 8.46875 23.75 9.13281 23.75 9.79688V10.5V11.75V14.25C24.4141 14.25 25 14.8359 25 15.5C25 16.2031 24.4141 16.75 23.75 16.75H22.5C22.5 18.8203 20.8203 20.5 18.75 20.5C16.6797 20.5 15 18.8203 15 16.75H10C10 18.8203 8.32031 20.5 6.25 20.5C4.17969 20.5 2.5 18.8203 2.5 16.75H1.875C0.820312 16.75 0 15.9297 0 14.875V2.375C0 1.35938 0.820312 0.5 1.875 0.5ZM16.25 6.75V10.5H21.25V9.79688L18.2031 6.75H16.25ZM4.375 16.75C4.375 17.4531 4.72656 18.0391 5.3125 18.3906C5.85938 18.7422 6.60156 18.7422 7.1875 18.3906C7.73438 18.0391 8.125 17.4531 8.125 16.75C8.125 16.0859 7.73438 15.5 7.1875 15.1484C6.60156 14.7969 5.85938 14.7969 5.3125 15.1484C4.72656 15.5 4.375 16.0859 4.375 16.75ZM18.75 14.875C18.0469 14.875 17.4609 15.2656 17.1094 15.8125C16.7578 16.3984 16.7578 17.1406 17.1094 17.6875C17.4609 18.2734 18.0469 18.625 18.75 18.625C19.4141 18.625 20 18.2734 20.3516 17.6875C20.7031 17.1406 20.7031 16.3984 20.3516 15.8125C20 15.2656 19.4141 14.875 18.75 14.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.aceb3a671923d09d6ac9eef0695e41b9.svg";
export { ForwardRef as ReactComponent };